import { GetAuditReportOutput } from '../types/backendService';

export const getAuditReportStub = (): GetAuditReportOutput => ({
  auditItems: [
    {
      performedBy: 'adminUser',
      auditType: 'Quality Audit',
      dateSubmitted: Math.floor(Date.now() / 1000) - 86400,
      result: 'PASS',
    },
    {
      performedBy: 'adminUser',
      auditType: 'Safety Audit',
      dateSubmitted: Math.floor(Date.now() / 1000) - 604800,
      result: 'FAIL',
    },
  ],
});
